import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class LinkService {
    private _maxStack = 2;
    private _blobStack = [];
    private _urlCreator: {
        createObjectURL(object: any): string;
        revokeObjectURL(url: string): void;
    };

    public constructor(private _domSanitizer: DomSanitizer) {
        this._urlCreator = window.URL || (window as any).webkitURL;
    }

    public openLink(href: string, options: { target?: string; description?: string } = {}) {
        const { target, description } = Object.assign({ target: '_blank' }, options);
        const link = document.createElement('a') as any;
        link.href = href;
        if (description) {
            link.download = description;
        }
        link.target = target;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public openBlob(
        blobData: ArrayBuffer,
        options: { target?: string; description?: string; mime?: string }
    ) {
        options = Object.assign(
            { target: '_blank', mime: 'application/octet-stream' },
            options
        );

        const blob = new Blob([blobData], { type: options.mime });
        const blobUrl = this.getBlobUrl(blob);

        if ((navigator as any).msSaveOrOpenBlob) {
            (navigator as any).msSaveBlob(blob, options.description);
        } else {
            this.openLink(blobUrl, options);
        }
    }

    public getBlobUrl(blob: Blob) {
        return this._store(this._urlCreator.createObjectURL(blob));
    }

    private _store(blob: string) {
        // @ts-ignore
        this._blobStack.push(blob);
        while (this._blobStack.length > this._maxStack) {
            // @ts-ignore
            this._urlCreator.revokeObjectURL(this._blobStack.shift());
        }
        return blob;
    }
}